import script from "./coupone.vue?vue&type=script&setup=true&lang=js"
export * from "./coupone.vue?vue&type=script&setup=true&lang=js"

import "./coupone.vue?vue&type=style&index=0&id=45cbc577&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45cbc577"]])

export default __exports__